var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-pop-edit-container"},[_c('a-modal',{attrs:{"title":"主播列表","visible":_vm.visible,"confirm-loading":_vm.confirmLoading,"width":"700px"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.row,"loading":_vm.loading,"size":"middle"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }